import { render, staticRenderFns } from "./ScreenScrollContainer.vue?vue&type=template&id=dc5a878c&"
import script from "./ScreenScrollContainer.vue?vue&type=script&lang=js&"
export * from "./ScreenScrollContainer.vue?vue&type=script&lang=js&"
import style0 from "./ScreenScrollContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports